if (!customElements.get('refrigerated-cart-control')) {
  // const REFRIGERATED_CEP_RANGES = [
  //   [1000000, 5999999],
  //   [8000000, 8499999],
  // ];
  const REFRIGERATED_CEP_RANGES = [
    [1000000, 99000000]
  ];

  const normalizeCep = (value) => value.replace(/\D/g, '').slice(0, 8);

  const formatCep = (value) => {
    const cep = normalizeCep(value);
    return cep.length > 5 ? `${cep.slice(0, 5)}-${cep.slice(5)}` : cep;
  };

  const evaluateCep = (value) => {
    const cep = normalizeCep(value);

    if (cep.length === 0) return 'empty';
    if (cep.length < 8) return 'incomplete';

    const cepNumber = Number(cep);
    return REFRIGERATED_CEP_RANGES.some(([minimum, maximum]) => cepNumber >= minimum && cepNumber <= maximum)
      ? 'ok'
      : 'outside';
  };

  const updateCheckoutButtons = (status) => {
    const isAvailable = status === 'ok';

    document.querySelectorAll('[data-refrigerated-checkout]').forEach((button) => {
      button.disabled = !isAvailable;
      button.setAttribute('aria-disabled', String(!isAvailable));
    });
  };

  const updateAllControls = (value, status) => {
    document.querySelectorAll('refrigerated-cart-control').forEach((control) => {
      control.updateState(value, status);
    });
    updateCheckoutButtons(status);
  };

  class RefrigeratedCartControl extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.input = this.querySelector('[data-refrigerated-cep]');
      this.alert = this.querySelector('[data-refrigerated-alert]');
      this.removeButton = this.querySelector('[data-remove-refrigerated]');
      this.onInput = this.onInput.bind(this);
      this.onRemove = this.onRemove.bind(this);

      this.input?.addEventListener('input', this.onInput);
      this.removeButton?.addEventListener('click', this.onRemove);

      const formattedValue = formatCep(this.input?.value || '');
      const status = evaluateCep(formattedValue);
      this.updateState(formattedValue, status);
      updateCheckoutButtons(status);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.removeButton?.removeEventListener('click', this.onRemove);
      window.clearTimeout(this.saveTimer);
      this.initialized = false;
    }

    getMessage(status) {
      const messageKey = `message${status.charAt(0).toUpperCase()}${status.slice(1)}`;
      return this.dataset[messageKey] || '';
    }

    updateState(value, status) {
      if (this.input && this.input.value !== value) this.input.value = value;

      this.dataset.status = status;
      this.input?.setAttribute('aria-invalid', String(status !== 'ok'));

      if (this.alert) {
        this.alert.textContent = this.getMessage(status);
        this.alert.className = `refrigerated-cart__alert refrigerated-cart__alert--${status}`;
      }

      if (this.removeButton) this.removeButton.hidden = status !== 'outside';

      document
        .querySelectorAll(
          `.cart-shipping-group[data-cart-surface="${this.dataset.cartSurface}"][data-shipping-group="refrigerated"]`
        )
        .forEach((group) => group.classList.toggle('is-blocked', status === 'outside'));
    }

    onInput() {
      const formattedValue = formatCep(this.input.value);
      const status = evaluateCep(formattedValue);

      updateAllControls(formattedValue, status);
      window.clearTimeout(this.saveTimer);
      this.saveTimer = window.setTimeout(() => this.saveCep(formattedValue), 500);
    }

    async saveCep(value) {
      try {
        const response = await fetch(this.dataset.cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes: { CEP: value } }),
        });

        if (!response.ok) throw new Error(`Cart update failed with ${response.status}`);
      } catch (error) {
        console.error('Failed to save refrigerated delivery postal code', error);
      }
    }

    async onRemove() {
      const lineKeys = Array.from(
        document.querySelectorAll(
          `.cart-shipping-group[data-cart-surface="${this.dataset.cartSurface}"] [data-refrigerated-line-key]`
        )
      ).map((item) => item.dataset.refrigeratedLineKey);
      const updates = Object.fromEntries([...new Set(lineKeys)].map((key) => [key, 0]));

      if (Object.keys(updates).length === 0) return;

      const defaultLabel = this.removeButton.dataset.labelDefault;
      this.removeButton.disabled = true;
      this.removeButton.textContent = this.removeButton.dataset.labelLoading;

      try {
        const response = await fetch(this.dataset.cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) throw new Error(`Cart removal failed with ${response.status}`);

        const destination = this.dataset.hasStandard === 'true' ? this.dataset.checkoutUrl : this.dataset.cartUrl;
        window.location.assign(destination);
      } catch (error) {
        console.error('Failed to remove refrigerated products', error);
        this.removeButton.disabled = false;
        this.removeButton.textContent = defaultLabel;
        this.alert.textContent = this.dataset.messageRemoveError;
        this.alert.className = 'refrigerated-cart__alert refrigerated-cart__alert--outside';
      }
    }
  }

  customElements.define('refrigerated-cart-control', RefrigeratedCartControl);
}
